

export interface PriorityInterface {

    getTitle(): string
    getName(): string
    getColor(): string
    getId(): number;
}

export class Priority implements PriorityInterface{

    constructor(private props : {id: number, color: string, title?: string}){

    }

    getId(): number {
        return this.props.id;
    }

    getColor(): string {
        return this.props.color;
    }

    getName(){
        return "P"+this.props.id
    }
    getTitle(){
        return this.props.title;
    }

}


export const PRIORITIES: readonly Priority[] = [
    new Priority({id:4, color: "#de4c4a", title: "Важное срочное"}),
    new Priority({id:3, color: "#f49c17", title: "Важное не срочное"}),
    new Priority({id:2, color: "#3e73d6", title: "Не важное срочное"}),
    new Priority({id:1, color: "#dcdcdc", title: "Не важное не срочное"})
];
